import React from "react";
import dmImage from '../../assets/images/digitalmarketing.jpg';

const DigitalmarketingMain = () => {
  return (
    <section className="min-h-screen pb-10 bg-white">

      {/* Main Content */}
      <div className="container max-w-6xl px-4 mx-auto mt-8">
        <div className="flex flex-col items-center gap-8 md:flex-row md:items-start">
          {/* Left: Course Image */}
          <div className="w-full md:w-1/2" data-aos="fade-right">
            <img src={dmImage} alt="Digital Marketing" className="w-full h-auto rounded-lg shadow-lg" />
          </div>
          {/* Right: Course Intro */}
          <div className="w-full p-2 md:w-1/2" data-aos="fade-left">
            <h2 className="text-2xl font-bold mb-2 text-[#A14D1F]">Master Digital Marketing with Sunrising Cinevision Academy</h2>
            <p className="mb-4 text-gray-700">
              Sunrising Cinevision Academy offers a comprehensive Digital Marketing course designed to equip you with the latest skills and strategies in the digital landscape. Learn from industry experts and gain hands-on experience in SEO, SEM, social media, content marketing, analytics, and more. Whether you're a business owner, student, or marketing enthusiast, this course will help you become an industry-ready digital marketing professional.
            </p>
            <h2 className="text-xl font-bold mb-2 text-[#A14D1F]">What You Will Learn</h2>
            <ul className="pl-5 mb-2 space-y-1 text-gray-700 list-disc">
              <li>Search Engine Optimization (SEO) fundamentals and advanced strategies</li>
              <li>Search Engine Marketing (SEM) and Pay-Per-Click (PPC) campaigns</li>
              <li>Social Media Marketing across platforms (Facebook, Instagram, LinkedIn, etc.)</li>
              <li>Content Marketing, Blogging, and Copywriting</li>
              <li>Email Marketing, Automation, and CRM tools</li>
              <li>Web Analytics and Conversion Optimization</li>
              <li>Branding, Influencer Marketing, and Online Reputation Management</li>
            </ul>
          </div>
        </div>

        {/* Course Modules */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-right">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Foundational Modules:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Introduction to Digital Marketing</li>
              <li>Website Planning & Development Basics</li>
              <li>SEO Fundamentals</li>
              <li>Content Marketing Essentials</li>
              <li>Social Media Overview</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-left">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Core Modules:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Advanced SEO Techniques</li>
              <li>Google Ads & SEM</li>
              <li>Social Media Marketing (Facebook, Instagram, LinkedIn, Twitter)</li>
              <li>Email Marketing & Automation</li>
              <li>Analytics & Reporting</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-right">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Specialization Modules:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Influencer & Affiliate Marketing</li>
              <li>Online Reputation Management</li>
              <li>Mobile Marketing</li>
              <li>Video Marketing & YouTube SEO</li>
              <li>E-commerce Marketing</li>
            </ol>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-left">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Capstone & Career:</h3>
            <ol className="pl-5 space-y-1 text-gray-700 list-decimal">
              <li>Live Projects & Case Studies</li>
              <li>Digital Marketing Strategy Building</li>
              <li>Freelancing & Agency Setup</li>
              <li>Interview Preparation</li>
              <li>Portfolio Development</li>
            </ol>
          </div>
        </div>

        {/* Instructors & More */}
        <div className="p-10 mt-10 bg-white shadow-md rounded-xl">
          <h2 className="text-3xl font-bold text-center mb-10 text-[#A14D1F]">Learn from Industry Experts</h2>
          <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Digital Marketing Mentors:</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Neil Patel</li>
                <li>Sorav Jain</li>
                <li>Deepak Kanakaraju</li>
                <li>Pradeep Chopra</li>
                <li>Jitendra Vaswani</li>
              </ul>
            </div>
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Guest Speakers:</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Rohit Onkar (Marketing Head, FoxyMoron)</li>
                <li>Vaibhav Sisinty (Growth Hacker)</li>
                <li>Harsh Agrawal (ShoutMeLoud)</li>
                <li>Priya Florence Shah</li>
                <li>Industry Agency Leaders</li>
              </ul>
            </div>
            <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
              <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Career Support:</h3>
              <ul className="pl-5 space-y-1 text-gray-700 list-disc">
                <li>Resume & LinkedIn Profile Building</li>
                <li>Mock Interviews</li>
                <li>Job Placement Assistance</li>
                <li>Freelancing Guidance</li>
                <li>Alumni Networking</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Partnerships, Alumni, Certifications, Scholarships, Duration, Outcomes */}
        <div className="grid grid-cols-1 gap-6 mt-10 md:grid-cols-2">
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Industry Partnerships</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Google India</li>
              <li>Facebook Meta</li>
              <li>HubSpot</li>
              <li>SEMrush</li>
              <li>Local Digital Agencies</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Alumni Network</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Connect with digital marketing professionals across industries.</li>
              <li>Participate in mentorship and networking events.</li>
              <li>Access exclusive job opportunities.</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Certifications Offered</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Certificate in Digital Marketing</li>
              <li>Advanced Digital Marketing Certification</li>
              <li>Google Ads & Analytics Certification (Guidance)</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Scholarship Opportunities</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Merit-based scholarships</li>
              <li>Need-based scholarships</li>
              <li>Women in Digital Scholarships</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Course Duration</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Certification Course – 3 months</li>
              <li>Advanced Certification – 6 months</li>
              <li>Weekend/Online Batches Available</li>
            </ul>
          </div>
          <div className="p-8 bg-white shadow-md rounded-xl" data-aos="fade-up">
            <h3 className="uppercase tracking-wide text-xl font-bold text-[#A14D1F]">Key Learning Outcomes</h3>
            <ul className="pl-5 space-y-1 text-gray-700 list-disc">
              <li>Plan and execute successful digital marketing campaigns.</li>
              <li>Master SEO, SEM, social media, and analytics tools.</li>
              <li>Develop content strategies for brand growth.</li>
              <li>Analyze and optimize marketing performance.</li>
              <li>Build a strong digital portfolio and career network.</li>
            </ul>
          </div>
        </div>

        {/* Call to Action */}
        <div className="p-8 mt-10 text-center bg-white shadow-md rounded-xl" data-aos="fade-up">
          <h3 className="uppercase tracking-wide text-lg font-bold mb-4 text-[#A14D1F]">Start Your Digital Marketing Journey Today!</h3>
          <p className="mb-6 text-gray-700">Enroll in the Digital Marketing course at Sunrising Cinevision Academy and take your first step toward becoming a digital marketing expert.</p>
          <a href="/admission" className="inline-block px-8 py-3 text-lg font-bold text-white bg-gradient-to-r from-[#A14D1F] via-[#A14D1F] to-[#4A2F24] rounded-2xl shadow-lg hover:scale-105 transition-transform">Apply Now</a>
        </div>
      </div>
    </section>
  );
};

export default DigitalmarketingMain;
